export const privacyData = {
  title: "Privacy Policy",
  content: [
    {
      title: "1. General information",
      text: "Thank you for visiting our website and for your interest in our content. The protection of your personal data is very important to us. This privacy policy informs you about the collection and use of personal data in connection with the use of our website. This English translation is provided for convenience; the German version is legally binding."
    },
    {
      title: "2. Controller",
      text: "The controller responsible for data processing is:",
      content: [
        'Robin Wichmann',
        'Hauptstr. 58c',
        '21640 Bliedersdorf',
        'E-mail: kontakt@robinwichmann.com'
      ],
      type: 'address'
    },
    {
      title: "3. No personal data",
      text: "Our website does not collect any personal data such as names, e-mail addresses, or other personal information. We do not store any user data and do not use tracking cookies."
    },
    {
      title: "4. Audience measurement with Matomo (self-hosted)",
      text: "We use Matomo, a self-hosted, privacy-friendly web analytics software, to generate general usage statistics. The Matomo instance runs on our own server (matomo.dudehub.de), and no data is transferred to third parties.\n\nOur Matomo setup is configured to run without cookies (\"disableCookies\") and does not store any identifiers on your device.\n\nYour IP address is used exclusively server-side and transiently when a page is loaded, to determine the approximate geographic origin (country, region, city) from a local geolocation database. Immediately afterwards, it is truncated by 2 bytes, so that only the anonymized form (e.g. 85.209.xxx.xxx) is stored in the database. The full IP address is never stored permanently.\n\nOnly anonymous, non-identifiable information is collected, such as page views, time on site, referrers, browser and device type, and the determined geographic origin.\n\nIt is not possible to link this data to a specific person. Since no cookies are set and no personal data is stored permanently, current case law does not require a consent banner."
    },
    {
      title: "5. No use of cookies",
      text: "Our website does not use cookies, and no personal data is collected or stored."
    },
    {
      title: "6. Security measures",
      text: "We take all necessary technical and organizational measures to protect your data from loss, misuse, or unauthorized access. However, since this is a static website, no personal data is involved, and the tools we use are designed to protect users' privacy."
    },
    {
      title: "7. Links to other websites",
      text: "Our website may contain links to external websites. We have no influence over the content of these sites and accept no responsibility for their privacy practices. Please note that the privacy policy of the respective provider applies to each of these sites."
    },
    {
      title: "8. Your rights",
      text: "Since we do not collect any personal data, you do not need to take any measures to control your data. If you nevertheless have questions about your privacy or data protection, you can contact us at any time."
    },
    {
      title: "9. Changes to this privacy policy",
      text: "We reserve the right to change this privacy policy at any time in order to adapt it to legal requirements or to reflect changes to our services. The current version of this privacy policy always applies."
    }
,
    {
      title: "10. Sign-in and comments",
      text: "On some pages you can comment on posts. This requires signing in with Google (Apple to follow). When you sign in, the provider shares your name, your email address and, where available, a profile picture; we store this data together with your comments in our database. Processing takes place to provide the comment feature, based on Art. 6(1)(b) GDPR. Comments are reviewed before publication. We will delete your account and your comments on request to the contact address below."
    }
  ]
};
